module.exports = __webpack_public_path__ + "img/ad2.e8f58d6e.png";